import { List, Typography } from "antd"
import React from "react"
import { useNavigate } from "react-router-dom"

import { RowCardList } from "../rows/RowCardList"
import { neutral } from "../tokens"
import { rowsPayloadOf } from "../rowsFormat"
import type { WidgetProps, WidgetState } from "../types"
import { WidgetFrame } from "../WidgetFrame"

export const ListWidget = ({
  widget,
  payload,
  state,
  currency,
  onRefresh,
  onExpand,
  onDrill
}: WidgetProps) => {
  const navigate = useNavigate()
  const rowsData = payload ? rowsPayloadOf(payload) : undefined
  const legacyItems = payload?.list?.items
  const title = widget.config?.title ?? widget.title
  const effectiveCurrency = currency ?? payload?.currency

  const rowCount = rowsData ? rowsData.rows.length : legacyItems?.length

  let effectiveState: WidgetState
  if (state && state !== "ready") {
    effectiveState = state
  } else if (rowCount === undefined) {
    effectiveState = "loading"
  } else if (rowCount === 0) {
    effectiveState = "empty"
  } else {
    effectiveState = "ready"
  }

  const goTo = (target: string) => (onDrill ? onDrill(target) : navigate(target))

  const frame = (children: React.ReactNode) => (
    <WidgetFrame
      title={title}
      state={effectiveState}
      capabilities={widget.capabilities}
      widgetId={widget.id}
      payload={payload}
      onRefresh={onRefresh}
      onExpand={onExpand}
    >
      {children}
    </WidgetFrame>
  )

  if (rowsData) {
    return frame(
      <RowCardList data={rowsData} currency={effectiveCurrency} onOpen={goTo} />
    )
  }

  return frame(
    <List
      size="small"
      dataSource={legacyItems ?? []}
      renderItem={(item) => (
        <List.Item key={item.id}>
          <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <Typography.Text>{item.primary}</Typography.Text>
            {item.secondary && (
              <Typography.Text style={{ fontSize: 12, color: neutral.muted }}>
                {item.secondary}
              </Typography.Text>
            )}
          </div>
        </List.Item>
      )}
    />
  )
}
